<!-- Sem `windowMode`, como nas outras duas moldura: ele recua o topo e limita a largura. -->
<nb-layout class="layout-inscricao-pub">
  <nb-layout-header fixed class="inscricao-pub-header">
    <div class="inscricao-pub-bar">
      <div class="inscricao-pub-marca">
        <img src="assets/domus-data-logo.png?v=2" alt="DOMUS DATA" class="inscricao-pub-logo" />
        <div class="inscricao-pub-textos">
          <span class="inscricao-pub-titulo">Inscrição — Catequese</span>
          <span class="inscricao-pub-sub">Preencha o formulário abaixo. Você não precisa estar logado.</span>
        </div>
      </div>
    </div>
  </nb-layout-header>

  <nb-layout-column class="inscricao-pub-column">
    <router-outlet></router-outlet>
  </nb-layout-column>
</nb-layout>
